import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import { store } from "./store";
import axios from "axios";
import "./custom.scss";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);

Bugsnag.start({
  apiKey: "19989cbfbc7e8997ccc50016d90cebda",
  plugins: [new BugsnagPluginVue()]
});

const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(Vue);

Vue.prototype.$axios = axios;
axios.defaults.baseURL = "https://www.taxtim.com/api/";
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    localStorage.setItem("awslbcors", response.headers["Set-Cookie"]);
    console.log(response.headers);
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

const router = new VueRouter({
  routes
});

Vue.prototype.$globalRouter = router;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
